if (!customElements.get("size-helper")) {
  customElements.define(
    "size-helper",
    class SizeHelper extends HTMLElement {
      constructor() {
        super();

        this.gender = this.getAttribute("data-gender");
        this.type = this.getAttribute("data-type");

        this.sizeSelect = this.querySelector("#SizeHelperSize");
        this.heightSelect = this.querySelector("#SizeHelperHeight");
        this.resultInput = this.querySelector("#SizeHelperResult");

        if (this.sizeSelect && this.heightSelect && this.resultInput) {
          this.sizeSelect.addEventListener("change", () => this.updateResult());
          this.heightSelect.addEventListener("change", () =>
            this.updateResult()
          );
          this.updateResult();
        }
      }

      updateResult() {
        const size = parseInt(this.sizeSelect.value, 10);
        const height =
          this.type === "Short"
            ? "standard"
            : this.type === "Pantacourt" && this.heightSelect.value === "long"
            ? "standard"
            : this.heightSelect.value;

        const sizeMap =
          this.gender === "Femme"
            ? {
                short: {
                  32: 16,
                  34: 17,
                  36: 18,
                  38: 19,
                  40: 20,
                  42: 21,
                  44: 22,
                  46: 23,
                  48: 24,
                  50: 25,
                  52: 26,
                  54: 27,
                },
                standard: {
                  32: 32,
                  34: 34,
                  36: 36,
                  38: 38,
                  40: 40,
                  42: 42,
                  44: 44,
                  46: 46,
                  48: 48,
                  50: 50,
                  52: 52,
                  54: 54,
                },
                long: {
                  32: 64,
                  34: 68,
                  36: 72,
                  38: 76,
                  40: 80,
                  42: 84,
                  44: 88,
                  46: 92,
                  48: 96,
                  50: 100,
                  52: 104,
                  54: 108,
                },
              }
            : {
                short: {
                  36: 88,
                  38: 92,
                  40: 96,
                  42: 100,
                  44: 104,
                  46: 108,
                  48: 112,
                  50: 116,
                  52: 116,
                  54: 120,
                  56: 120,
                  58: 124,
                  60: 128,
                },
                standard: {
                  36: 44,
                  38: 46,
                  40: 48,
                  42: 50,
                  44: 52,
                  46: 54,
                  48: 56,
                  50: 58,
                  52: 58,
                  54: 60,
                  56: 60,
                  58: 62,
                  60: 64,
                },
                long: {
                  36: 144,
                  38: 146,
                  40: 148,
                  42: 150,
                  44: 152,
                  46: 154,
                  48: 156,
                  50: 158,
                  52: 158,
                  54: 160,
                  56: 160,
                  58: 162,
                  60: 164,
                },
              };

        if (sizeMap[height] && sizeMap[height][size]) {
          const result = sizeMap[height][size];
          this.resultInput.value = result;
          const sizeRadio = document.querySelector(
            `.product-size-accordion input[type="radio"][value="${result}"]`
          );
          if (sizeRadio && sizeRadio.checked !== true) {
            sizeRadio.checked = true;
            sizeRadio.dispatchEvent(new Event("change", { bubbles: true }));
          }
        } else {
          this.resultInput.value = "N/A";
        }
      }
    }
  );
}
